import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TransportActionBarWidgetComponent } from './component/transport-action-bar.component';
import { ActionsModule } from '../../../control/actions/actions.module';
import { TransportActionBarModule } from 'src/tmc-yard/control/transport-action-bar/transport-action-bar.module';

@NgModule({
  declarations: [
    TransportActionBarWidgetComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatInputModule,
    MatTooltipModule,
    ApplicationClientCommonModule,
    TransportActionBarModule,
    CommonTranslationModule,
    ActionsModule
  ],
  exports: [
    TransportActionBarWidgetComponent
  ]
})
export class TransportActionBarWidgetModule { }
